export default "__VITE_ASSET__d0a17bd8__"